import type { useActiveVisitorsQuery } from '../../queries/useActiveVisitorsQuery'

type ActiveVisitors = NonNullable<
  ReturnType<typeof useActiveVisitorsQuery>['activeVisitorsQuery']['data']
>

export type AvailableActiveVisitors = Extract<ActiveVisitors, { type: 'AVAILABLE' }>

export const isAvailable = (data: ActiveVisitors | undefined): data is AvailableActiveVisitors => {
  return data?.type === 'AVAILABLE'
}
